import { createContext, ReactNode, useContext } from 'react';
import { PredictionMarketItem } from '../types';

export type SearchMarketDialogState = {
  open: boolean;
  searchValue: string;
  selectedIds: Set<string>;
};

export type SearchMarketDialogActions = {
  setSearchValue: (value: string) => void;
  selectMarket: (market: PredictionMarketItem) => void;
};

export type SearchMarketDialogMeta = {
  selectedCount: number;
};

export type SearchMarketDialogContextValue = {
  state: SearchMarketDialogState;
  actions: SearchMarketDialogActions;
  meta: SearchMarketDialogMeta;
};

const SearchMarketDialogContext = createContext<SearchMarketDialogContextValue | null>(null);

export function SearchMarketDialogProvider({
  value,
  children,
}: {
  value: SearchMarketDialogContextValue;
  children: ReactNode;
}) {
  return (
    <SearchMarketDialogContext.Provider value={value}>
      {children}
    </SearchMarketDialogContext.Provider>
  );
}

export function useSearchMarketDialogContext() {
  const context = useContext(SearchMarketDialogContext);

  if (!context) {
    throw new Error('useSearchMarketDialogContext must be used within SearchMarketDialogProvider');
  }

  return context;
}
